import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import FeaturedGames from "@/components/FeaturedGames";
import Roster from "@/components/Roster";
import Tournaments from "@/components/Tournaments";
import LiveTwitch from "@/components/LiveTwitch";
import News from "@/components/News";
import Sponsors from "@/components/Sponsors";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function HomePage() {
  return (
    <div data-testid="home-page" className="relative">
      <Navbar />
      <main>
        <Hero />
        <FeaturedGames />
        <Roster />
        <Tournaments />
        <LiveTwitch />
        <News />
        <Sponsors />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
